import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Crown, Trophy, Users } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

export const RefMonthBadge = ({ testid = "ref-month-badge" }) => {
  const { t } = useI18n();
  return (
    <span data-testid={testid} className="inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-[#ffd34d] to-[#ff9d2e] px-2.5 py-0.5 text-[10px] font-bold text-black shadow-[0_0_14px_rgba(255,200,60,.55)]">
      <Crown className="w-3 h-3" />{t("rl.badge")}
    </span>
  );
};

const Row = ({ r, t }) => {
  const name = r.handle ? <Link to={`/u/${r.handle}`} className="hover:text-[#3ad7ff]" data-testid={`ref-lb-link-${r.rank}`}>{r.name}</Link> : r.name;
  return (
    <div data-testid={`ref-lb-row-${r.rank}`}
      className={`flex items-center gap-3 rounded-xl px-3 py-2.5 border ${r.rank === 1 ? "border-[#ffd34d]/50 bg-[#ffd34d]/10" : r.me ? "border-[#3ad7ff]/50 bg-[#3ad7ff]/10" : "border-white/5 bg-black/30"}`}>
      <span className={`w-7 text-center font-display font-bold ${r.rank === 1 ? "text-[#ffd34d]" : r.rank <= 3 ? "text-[#c79bff]" : "text-slate-500"}`}>#{r.rank}</span>
      <span className="flex-1 min-w-0 truncate text-sm text-white flex items-center gap-2">{name}{r.rank === 1 && <RefMonthBadge testid="ref-lb-badge" />}{r.me && <span className="text-[10px] text-[#3ad7ff]">{t("rl.you")}</span>}</span>
      <span className="text-xs text-slate-300 flex items-center gap-1" data-testid={`ref-lb-friends-${r.rank}`}><Users className="w-3.5 h-3.5 text-[#22e3a1]" />{r.friends}</span>
    </div>
  );
};

export const ReferralLeaderboard = ({ className = "" }) => {
  const { t } = useI18n();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/referral/leaderboard").then((r) => setD(r.data)).catch(() => setD({ rows: [] })); }, []);
  return (
    <section className={`cx-card rounded-3xl p-5 sm:p-6 ${className}`} data-testid="ref-leaderboard">
      <div className="flex items-center gap-2 mb-1"><Trophy className="w-5 h-5 text-[#ffd34d]" /><h2 className="font-display text-lg font-bold text-white">{t("rl.title")}</h2></div>
      <p className="text-xs text-slate-400 mb-4">{t("rl.sub")}</p>
      {!d ? <div className="h-24 rounded-xl bg-white/5 animate-pulse" /> : d.rows.length ? (
        <div className="space-y-2">{d.rows.map((r) => <Row key={r.rank} r={r} t={t} />)}</div>
      ) : <p className="text-sm text-slate-400" data-testid="ref-lb-empty">{t("rl.empty")}</p>}
    </section>
  );
};
